import { iconPropsSchema } from '../component-catalog.js';
export const iconDefinition = {
    type: 'Icon',
    category: 'content',
    propsSchema: iconPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Single icon glyph by name. Props: name (required), color?, size?.',
};
//# sourceMappingURL=Icon.js.map